import { useEffect, useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { mediaSrc } from "./MediaPicker";
import { Megaphone } from "lucide-react";

// Okunmamış pop-up duyuruları sırayla gösterir; kapatınca okundu işaretlenir
export default function AnnouncementPopup() {
  const [queue, setQueue] = useState([]);
  useEffect(() => { api.get("/announcements/active").then((r) => setQueue(r.data.filter((a) => a.popup && !a.read))).catch(() => {}); }, []);
  const cur = queue[0];
  const close = async () => { if (!cur) return; try { await api.post(`/announcements/${cur.id}/read`); } catch { /* */ } setQueue((q) => q.slice(1)); };
  return (
    <Dialog open={!!cur} onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="announcement-popup" className="max-w-md">
        {cur && (<>
          <DialogHeader><DialogTitle className="flex items-center gap-2"><Megaphone className="h-5 w-5 text-blue-600" />{cur.title}</DialogTitle></DialogHeader>
          {cur.image_url && <img src={mediaSrc(cur.image_url)} alt="" className="rounded-lg w-full max-h-72 object-contain bg-slate-50" />}
          {cur.body && <div className="text-sm whitespace-pre-wrap text-slate-700">{cur.body}</div>}
          <Button onClick={close} className="bg-blue-600 hover:bg-blue-700" data-testid="announcement-ok">Okudum{queue.length > 1 ? ` (${queue.length - 1} duyuru daha)` : ""}</Button>
        </>)}
      </DialogContent>
    </Dialog>
  );
}
